import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0fef60d2"
import script from "./Header.js?vue&type=script&lang=js&external"
export * from "./Header.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports